import { Controller } from "@hotwired/stimulus";
import Toastify from "toastify-js";

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    const type = this.element.dataset.notice;
    Toastify({
      text: this.element.innerHTML,
      duration: 2000,
      gravity: "top",
      position: "center",
      backgroundColor: type === "alert" ? "#dc2626" : "#047857",
    }).showToast();
    setTimeout(() => {
      this.element.remove();
    }, 2000);
  }
}
